import { ContentBlockType, RecipeBlock } from '../../../model';

export const RECIPE_NODE_NAME = 'recipe';
export const RECIPE_STEP_NODE_NAME = 'recipeStep';

export const DEFAULT_RECIPE_STEP_TITLE = 'New Step';

export const DEFAULT_RECIPE_PROPS = {
  type: ContentBlockType.Recipe,
  steps: [{ title: 'Step 1', content: [] }],
} as const satisfies Partial<RecipeBlock>;
